import React from 'react';
import { Typography } from '@mui/material';
import CustomTable from '../../../../../components/Table/CustomTable';
import Loader from '../../../../../components/Loader';
import moment from 'moment';
import AcceptTickets from './AcceptTickets';

// Column definitions for the table
const pendingRequestsColumns = [
  {
    field: "client",
    headerName: "Client",
    renderCell: (params) => (
      <Typography variant="body2">{params.value}</Typography>
    ),
    minWidth: 150,
    flex: 1,
    sortable: false,
  },
  {
    field: "building_address",
    headerName: "Building",
    renderCell: (params) => (
      <Typography variant="body2">{params.value}</Typography>
    ),
    minWidth: 180,
    flex: 1.5,
    sortable: false,
  },
  {
    field: "unit_number",
    headerName: "Unit",
    renderCell: (params) => ( params.value ?
      <Typography variant="body2" className="unit-chip">
        {params.value}
      </Typography> :
      <Typography variant="body2">N/A</Typography>
    ),
    minWidth: 80,
    flex: 0.5,
    sortable: false,
  },
  {
    field: "violation_code",
    headerName: "Violation Code",
    renderCell: (params) => (
      <Typography variant="body2">{params.row.violation.order_number}</Typography>
    ),
    minWidth: 120,
    flex: 1,
    sortable: false,
  },
  {
    field: "violation_id",
    headerName: "Violation #",
    renderCell: (params) => (
      <Typography variant="body2">{params.row.violation.violation_id}</Typography>
    ),
    minWidth: 120,
    flex: 1,
    sortable: false,
  },
  {
    field: "correct_by_date",
    headerName: "Correct Date",
    renderCell: (params) => (
      <Typography variant="body2">
        {params.row.violation.correct_by_date ? moment(params.row.violation.correct_by_date).format("MM/DD/YYYY") : "N/A"}
      </Typography>
    ),
    minWidth: 120,
    flex: 1,
    sortable: false,
  },
  {
    field: "certify_by_date",
    headerName: "Certify Date",
    renderCell: (params) => (
      <Typography variant="body2">
        {params.row.violation.certify_by_date ? moment(params.row.violation.certify_by_date).format("MM/DD/YYYY") : "N/A"}
      </Typography>
    ),
    minWidth: 120,
    flex: 1,
    sortable: false,
  },
  {
    field: "action",
    headerName: "Action",
    renderCell: (params) => <AcceptTickets row={params.row} />,
    minWidth: 120,
    flex: 1,
    sortable: false,
  },
];

const Table = ({ 
  isLoading, 
  data, 
  page, 
  pageSize, 
  setPage, 
  setPageSize,
  totalRecords
}) => {


  if (isLoading) {
    return (
      <div className="loader-center">
        <Loader color={"black"} />
      </div>
    );
  }

  return (
    <CustomTable
      initialRows={data}
      columns={pendingRequestsColumns}
      headerBgColor={"#F5F5F9"}
      rowCount={totalRecords}
      setPaginationModel={(data) => {
        setPage(data.page);
        setPageSize(data.pageSize);
      }}
      page={page}
      pageSize={pageSize}
      subHeight={302}
    />
  );
};

export default Table; 